export const stepsArray = [
  { step: 'actionPlan.step1', label: 'actionPlan.step1Label' },
  { step: 'actionPlan.step2', label: 'actionPlan.step2Label' },
  { step: 'actionPlan.step3', label: 'actionPlan.step3Label' },
  { step: 'actionPlan.step4', label: 'actionPlan.step4Label' },
]

